module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<style>\n    .range-control {\n        position : relative;\n        padding  : 0 12px;\n    }\n\n    .range-control .placeholder {\n        display                  : inline-block;\n        color                    : #6D6E71;\n        position                 : relative;\n        text-align               : right;\n        top                      : -0.085em;\n        width                    : 100%;\n        -webkit-transform-origin : right;\n        transform-origin         : right;\n        -webkit-transition       : all 0.35s linear;\n        transition               : all 0.35s linear;\n    }\n\n    .range-control .placeholder.active {\n        color             : black;\n        -webkit-transform : scale(1.7);\n        -ms-transform     : scale(1.7);\n        transform         : scale(1.7);\n    }\n</style>\n<div class=\"range-control flex flex-middle\">\n    <div class=\"flex-item\">\n        <div class=\"slider\"></div>\n    </div>\n    <div class=\"flex-none\" style=\"width: 25%\">\n        <span class=\"placeholder\"></span>\n    </div>\n</div>\n")
  }
  return __output.join("");

}